/* eslint-disable max-len */
import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { bem } from '@argos/utils'
import Button from '@boltui/button'

const cn = bem({ prefix: 'lc-', block: 'feedback-text-area' })
const maxLength = 255

const FeedbackTextArea = ({
  buttonText,
  hasError,
  id,
  onChange,
  onSubmit,
  question,
  regex = {},
  trackingCode,
  value,
}) => {
  const { description } = regex
  return (
    <div className={`${cn()} lc-controls__form lc-controls__form--with-seperator`}>
      <div className={cn('question-text')}>{question}</div>

      {description && (
        <span className={`lc-controls__desc ${hasError ? 'lc-controls__desc--error' : ''}`}>{description}</span>
      )}

      <textarea
        className={cn('textarea')}
        onChange={(evt) => {
          onChange(evt.target.value)
        }}
        value={value}
        name='message'
        maxLength={maxLength}
        cols='20'
        rows='5'
      />
      <Button
        full
        data-test={cn('btn-next')}
        className={`${cn('btn-next')} button`}
        onClick={() => onSubmit({ id, value, trackingCode })}>
        {buttonText}
      </Button>
    </div>
  )
}

FeedbackTextArea.propTypes = {
  buttonText: PropTypes.string,
  hasError: PropTypes.bool,
  id: PropTypes.string,
  onChange: PropTypes.func,
  onSubmit: PropTypes.func,
  question: PropTypes.string,
  trackingCode: PropTypes.string,
  regex: PropTypes.shape({
    description: PropTypes.string,
  }),
  value: PropTypes.string,
}

const mapStateToProps = (state) => ({
  value: state.Forms.inputValue,
})

export default connect(mapStateToProps)(FeedbackTextArea)
